import { render, staticRenderFns } from "./PassportCznConfig.vue?vue&type=template&id=1c14f81f&scoped=true"
import script from "./PassportCznConfig.vue?vue&type=script&lang=js"
export * from "./PassportCznConfig.vue?vue&type=script&lang=js"
import style0 from "./PassportCznConfig.vue?vue&type=style&index=0&id=1c14f81f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c14f81f",
  null
  
)

export default component.exports